module.exports = __webpack_public_path__ + "img/tipimg_p@2x.269bf763.png";